'use strict';

import angular from 'angular';
import moment from 'angular-moment';
import {
  DateUtil
} from './date_util';

export default angular.module('leptonApp.DateUtil', [moment])
  .factory('DateUtil', ['$filter', 'moment', DateUtil])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/logic/date_util/date_util.module.js